import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { ReviewCandidatePullFromJobBoardsComponent } from './review-candidate-pull-from-job-boards.component';

@NgModule({
  declarations: [ReviewCandidatePullFromJobBoardsComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot()
  ],
  exports: [ReviewCandidatePullFromJobBoardsComponent],
  entryComponents: [ReviewCandidatePullFromJobBoardsComponent]
})
export class ReviewCandidatePullFromJobBoardsModule { }
